function Callendar() {
	this.init();
}

Callendar.prototype.init = function () {
	var self = this;
	$('body').on('click', '.events-calendar .events-calendar-nav-days span.-hoverable', function(e) {
		e.preventDefault();
		self.changeDay($(this));
	});
};

Callendar.prototype.changeDay = function(target) {
	var id = target.attr('data-day');
	if (target.hasClass('-active')) {
		target.closest('.events-calendar-nav-days').find('span').removeClass('-active');
		target.closest('.events-calendar').find('.events-calendar-item').removeClass('-active');
	} else {
		target.closest('.events-calendar-nav-days').find('span').removeClass('-active');
		target.closest('.events-calendar-nav-days').find('span[data-day='+id+']').addClass('-active');
		target.closest('.events-calendar').find('.events-calendar-item').removeClass('-active');
		target.closest('.events-calendar').find('.events-calendar-item[data-id="'+id+'"]').addClass('-active');
	}
};